
import {Component, Prop, Vue} from 'vue-property-decorator';
import LoyaltyCertTypeUpdateForm from '@/form/loyalty/loyaltyCertType/LoyaltyCertTypeUpdateForm';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';

@Component({
  components: {FormGroup}
})
export default class LoyaltyCertTypeUpdateComponent extends Vue {
  @Prop() readonly form!: LoyaltyCertTypeUpdateForm;
}
